var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeaker = function SvgSpeaker(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.9 12.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.83.6 4.706 3.062H1.83A1.23 1.23 0 0 0 .6 4.292V6.14a1.23 1.23 0 0 0 1.23 1.23h2.874L9.83 9.831zM4.908 9.831v.615a1.23 1.23 0 0 1-1.23 1.231h-.616a1.23 1.23 0 0 1-1.23-1.23V9.83M12.293 4.908h1.846M13.893.754l-1.6.923M12.293 8.139l1.6.923"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeaker);
export default ForwardRef;